import { Stack, Box, Typography, Paper, Chip } from "@mui/material";
import type { CollectionTypeShowData } from "@/admin/entities/collectionTypes";
import { CustomCellDate } from "@/shared/components";

const DISPLAY_MODE_LABELS: Record<string, string> = {
  HORIZONTAL: "Горизонтальный (16:9)",
  VERTICAL: "Вертикальный (2:3)",
};

interface CollectionTypeDetailsProps {
  collectionType: CollectionTypeShowData;
}

export function CollectionTypeDetails({
  collectionType,
}: CollectionTypeDetailsProps) {
  if (!collectionType) {
    return (
      <Paper sx={{ p: 2 }}>
        <Typography variant="h6" color="error">
          Запись не найдена
        </Typography>
      </Paper>
    );
  }

  return (
    <Paper sx={{ p: 2 }}>
      <Stack spacing={2}>
        <Typography variant="h6">{collectionType.title}</Typography>

        <Box>
          <Typography variant="body2" color="text.secondary" gutterBottom>
            Показывать в поиске
          </Typography>
          <Chip
            label={collectionType.showInSearch ? "Да" : "Нет"}
            color={collectionType.showInSearch ? "success" : "default"}
            size="small"
          />
        </Box>

        <Box>
          <Typography variant="body2" color="text.secondary">
            Режим превью
          </Typography>
          <Typography variant="body1">
            {collectionType.collectionDisplayMode
              ? (DISPLAY_MODE_LABELS[collectionType.collectionDisplayMode] ??
                collectionType.collectionDisplayMode)
              : "Дефолт платформы"}
          </Typography>
        </Box>

        <Box>
          <Typography variant="body2" color="text.secondary" gutterBottom>
            Создан
          </Typography>
          <CustomCellDate date={collectionType.createdAt} />
        </Box>
      </Stack>
    </Paper>
  );
}
